import { configureStore, Action } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
import { useDispatch } from "react-redux";

import authSlice from "../auth/authSlice";
import usersSlice from "../pages/users/usersSlice";
import tmsSlice from "../pages/liteTms/liteTmsSlice";
import wmsSlice from "../pages/liteWms/liteWmsSlice";
import tmsWhsSlice from "../pages/liteTmsWhs/liteTmsWhsSlice";
import offerSlice from "../pages/offerView/offerSlice";
import offersSlice from "../pages/offerList/offersSlice";
import stepsSlice from "../pages/offerCreate/stepsSlice";
import liteCustomsSlice from "../pages/liteCustoms/customsListSlice";
import ancillariesSlice from "../ancillaries/ancillarySlice";
import settingsSlice from "../pages/settings/settingsSlice";
import viewShippingSlice from "../pages/shippingView/shippingSlice";
import shippingListSlice from "../pages/shippingList/shippingListSlice";
import deliveryListSlice from "../pages/deliveryList/deliveryListSlice";
import whsDeliveryListSlice from "../pages/whsDeliveryList/whsDeliveryListSlice";
import createShippingSlice from "../pages/shippingCreate/createShippingSlice";

export const store = configureStore({
  devTools: process.env.NODE_ENV !== "production",
  reducer: {
    auth: authSlice,
    users: usersSlice,
    steps: stepsSlice,
    offer: offerSlice,
    liteWms: wmsSlice,
    liteTms: tmsSlice,
    liteTmsWhs: tmsWhsSlice,
    offers: offersSlice,
    settings: settingsSlice,
    liteCustoms: liteCustomsSlice,
    delivery: deliveryListSlice,
    whsDelivery: whsDeliveryListSlice,
    ancillaries: ancillariesSlice,
    shippingList: shippingListSlice,
    viewShipping: viewShippingSlice,
    createShipping: createShippingSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});
export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
